import { render, staticRenderFns } from "./ScreenLaudoTransvaginalHisterectomia.vue?vue&type=template&id=ca0e80e4&lang=true&"
import script from "./ScreenLaudoTransvaginalHisterectomia.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalHisterectomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports